<template>
  <div>
    <div class="line_chart"></div>
  </div>
</template>

<script>
import Highcharts from "highcharts/highstock";
export default {
  name: "LineChart",
  props: {
    seriesData: {
      type: Object,
      required: true,
    },
    title: {
      type: String,
      default: '',
    }
  },
  data() {
    return {
      chart: null,
    };
  },
  mounted() {
    this.initChart();
    // this.chart.showLoading();
  },
  watch: {
    seriesData: {
      handler(newValue) {
        if (this.chart) {
          this.chart.update({
            series: [{
              name: newValue.name,
              data: newValue.data,
            }],
          });
          this.chart.hideLoading();
        }
      }
    },
    title: function (val) {
      if (this.chart) {
        this.chart.update({
          title: {
            text: val + '每日订单数量',
          }
        });
      }
    },
  },
  methods: {
    initChart(){
      let that = this;
      this.chart = new Highcharts.Chart(this.$el, {
        credits: {
          enabled: false
        },
        title: {
          text: that.title + '每日订单数量',
        },
        yAxis: {
          title: {
            text: '订 单 数 量',
            style: {
              'font-size': '16px',
            }
          },
        },
        plotOptions: {
          line: {
            pointStart: 1,
          }
        },
        series: [{
          name: that.seriesData.name,
          data: that.seriesData.data,
        }],
        legend: {
          layout: 'vertical',
          align: 'right',
          verticalAlign: 'middle'
        },
        tooltip: {
          formatter: function () {
            return this.series.name + this.x +
                '日</br>订单数量：<b>' + this.y + '</b>';
          }
        },
        colors: ['rgb(121, 187, 255)'],
      })
    }
  }
}
</script>

<style scoped>

</style>
